module.exports = __webpack_public_path__ + "img/baht-sign.7f28cedf.svg";